import { render, staticRenderFns } from "./appSituation.vue?vue&type=template&id=6fb508dc&scoped=true"
import script from "./appSituation.vue?vue&type=script&lang=js"
export * from "./appSituation.vue?vue&type=script&lang=js"
import style0 from "./appSituation.vue?vue&type=style&index=0&id=6fb508dc&prod&lang=scss"
import style1 from "./appSituation.vue?vue&type=style&index=1&id=6fb508dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb508dc",
  null
  
)

export default component.exports